import { Fragment } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import {
  FontAwesomeIcon,
  CATEGORIES,
} from '@hivebrite/design-system/FontAwesomeIcon';

import { moneyFromCents } from 'hb-react/shared/apps/Memberships/utils/money';
import { translations } from 'hb-react/shared/apps/Memberships/utils/translations';
import { Price } from 'hb-react/shared/components/Price';

const Name = ({ name, quantity = 1, showOneQuantity = false }) =>
  quantity > 1 || showOneQuantity ? `${quantity} x ${name}` : name;

const Line = ({
  id,
  name,
  currency,
  quantity = 1,
  price: maybePrice = 0,
  original_total_in_cents: originalTotalInCents = 0,
  periodicity = null,
  onEdit,
  onDelete,
  show_one_quantity: showOneQuantity = false,
  has_free_trial: hasFreeTrial = false,
  free_trial_period_periodicity: freeTrialPeriodPeriodicity = null,
  wrapperProps,
}) => {
  const price =
    maybePrice || moneyFromCents(originalTotalInCents, currency.code).total;

  return (
    <Box justifyContent="space-between" flexGrow={1} {...wrapperProps}>
      <Box fontSize={1} font="body-semibold-asphalt" mr={2}>
        <Name
          name={name}
          quantity={quantity}
          showOneQuantity={showOneQuantity}
        />
        {onEdit && (
          <Button
            dataTestId={`edit-card-item-${id}`}
            icon={() => (
              <FontAwesomeIcon
                height="14px"
                iconName="pen"
                iconType={CATEGORIES.SOLID}
              />
            )}
            ml={2}
            onClick={onEdit}
            size="small"
            variant="inversed"
          />
        )}
        {onDelete && (
          <Button
            dataTestId={`delete-card-item-${id}`}
            icon={() => (
              <FontAwesomeIcon
                height="16px"
                iconName="xmark"
                iconType={CATEGORIES.SOLID}
              />
            )}
            ml={2}
            onClick={onDelete}
            size="small"
            variant="inversed"
          />
        )}
      </Box>
      <Box
        flexDirection="column"
        alignItems="flex-end"
        ml="auto"
        flexShrink={0}
      >
        <Box fontSize={1} textAlign="right">
          {hasFreeTrial &&
            `${s__('Memberships|Free')} / ${n__(
              '%{days} day',
              '%{days} days',
              freeTrialPeriodPeriodicity,
            ).i__({ days: freeTrialPeriodPeriodicity })}`}
        </Box>
        <Box flexDirection="row" fontSize={1} textAlign="right">
          <Price
            price={price * quantity}
            currency={currency}
            hasFreeTrial={hasFreeTrial}
          />
          {periodicity && `/${translations.periodicity[periodicity]}`}
        </Box>
      </Box>
    </Box>
  );
};

const ShoppingCardBody = ({ items }) => (
  <Box flexDirection="column" flexGrow={1} data-testid="shopping-card">
    <Box flexDirection="column" flexGrow={1}>
      {items.map(({ render, ...item }, index) => {
        if (typeof render === 'function') {
          return (
            <Fragment key={`card-item-${item.id}`}>{render(item)}</Fragment>
          );
        }

        return (
          <Line
            {...item}
            key={`card-item-${item.id}`}
            wrapperProps={{ mb: index < items.length - 1 ? 3 : 0 }}
          />
        );
      })}
    </Box>
  </Box>
);

export default ShoppingCardBody;
